import React, { Component } from 'react';

import * as User from './../helpers/User';
//const $=window.$;
const win=window;


class Linecharts extends Component {
	constructor(props) {
		super(props);
	}



   componentDidMount() {
    let titleText = this.props.title;
  	let types =this.props.charttype;
	let thisdata=this.props.data;
	for(const key in thisdata) {
		if(thisdata.hasOwnProperty(key)) {
			thisdata[key] =Math.round(thisdata[key] * 100) / 100;
		}
	}
		
       // window.test();
      setTimeout(()=>{
				win.Highcharts.chart(this.refs.highcharts, {					
				chart: {
						// borderColor:'white',
						// borderWidth:0.5,
						width:731,
						height:400,
						zoomType: 'none',
						},
						title: {
								text: this.props.title,
						},
						credits: {
								enabled:false,
						},
						xAxis: {
								categories: this.props.categories,
								title: {
										text: (this.props.belowtitle!=undefined)? this.props.belowtitle: 'Learning Rooms'
								},
						},
						yAxis: {
								title: {
										text: 'Percentage (%)'
								},
								plotLines: [{
										value: 0,
										width: 1,
										color: '#808080'
								}]
								},

								tooltip: {
									
										valueSuffix: '%',
										formatter: function () {return  (this.y>0) ? '<p style="font-size: 10px">'+this.x+'</p><br><p><span style="color:#7cb5ec" >●</span> Performance Score:  <b>'+this.y+' %</b>' : '<p style="font-size: 10px">'+this.x+'</p><br><p><span style="color:#7cb5ec" >●</span> Performance Score:  <b> N.A </b>' ;}
										
								},
								legend: {
										verticalAlign: 'bottom',
										layout: 'horizontal',
								},
								series: [{
										name: 'Performance Score',
										data: thisdata
								}]
						});


      },200);


    }





  render() {
    return (
      <div ref="highcharts"  style={{width:'98%'}} ></div>

    );
  }
}

export default Linecharts;



// WEBPACK FOOTER //
// ./src/components/Linecharts.js